import { NgModule, APP_INITIALIZER  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MapsComponent } from '../app/maps/maps.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MapListenersDirective } from '../app/maps/directive/map-listeners.directive';
import { AppConfigService } from './maps/services/app-config/app-config.service';

// tslint:disable-next-line
export function initConfig(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}

@NgModule({ declarations: [
        AppComponent,
        MapsComponent,
        MapListenersDirective,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule], providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [AppConfigService],
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule { }
